export default "__VITE_ASSET__B3rGH4SF__"